module.exports = __webpack_public_path__ + "img/streamline_cn.0dc93fa.jpg";